<template>
  <div id="list-dnt">
    <ApprovalFilters
      v-model="filters"
    />
    <FilesHeader />
    <div class="force-render" :key="forceRender">
      <FileRow
        :key="file.febosId"
        v-for="file in files"
        :file="file"
        :select-file="selectFile"
        data-cy="file"
      />
    </div>
    <PopUpBinnacleFile :titulo="'Bitácora del Expediente #'+selectedFile.numero"/>
    <PopUpCancelFile :canceledFile="selectedFile" />
    <FilesPagination
      :show="files.length"
      v-model="page"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FilesHeader from '@/febos/chile/approvals/components/approvalFiles/FilesHeader';
import FileRow from '@/febos/chile/approvals/components/approvalFiles/FileRow';
import ApprovalFilters from '@/febos/chile/approvals/components/ApprovalFilesFilters';
import FilesPagination from '@/febos/chile/approvals/components/approvalFiles/FilesPagination';
import PopUpCancelFile from '@/febos/chile/approvals/vistas/modals/PopUpCancelFile';
import PopUpBinnacleFile from '@/febos/chile/approvals/vistas/modals/PopUpBinnacleFile';

export default {
  components: {
    FilesPagination,
    ApprovalFilters,
    FileRow,
    FilesHeader,
    PopUpCancelFile,
    PopUpBinnacleFile
  },
  data() {
    return {
      selectedFile: {},
      filters: '',
      page: Number.parseInt(this.$route.query.page || 1, 10),
      paginate: Number.parseInt(this.$route.query.paginate || 10, 10),
      forceRender: Date.now() // TODO: the files watch is triggered but the component not re-render.
    };
  },
  watch: {
    files() {
      this.forceRender = Date.now(); // TODO: remove this.
    },
    filters(newValue) {
      this.listDocuments({
        data: {
          tipo: 'aprobaciones',
          campos: '*',
          pagina: 1,
          orden: '-fechaCreacion',
          itemsPorPagina: this.paginate,
          filtros: newValue
        }
      });
    },
    page(newValue) {
      this.listDocuments({
        data: {
          tipo: 'aprobaciones',
          campos: '*',
          pagina: newValue,
          orden: '-fechaCreacion',
          itemsPorPagina: this.paginate,
          filtros: this.filters
        }
      });
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#list-dnt > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#list-dnt',
        scale: 0.6
      });
    },
    successAction() {
      this.$bvToast.toast(
        'Acción realizada exitosamente',
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
    },
    error(error) {
      if (error !== '') {
        this.$bvToast.toast(
          `${error}`,
          {
            title: '¡Genial!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        this.clearErrorMessage();
      }
    }
  },
  computed: {
    ...mapGetters('Approvals', [
      'loading',
      'error',
      'successAction',
      'files'
    ])
  },
  methods: {
    ...mapActions('Approvals', [
      'listDocuments',
      'clearErrorMessage',
      'fetchDocumentTypeReferences'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    selectFile(file) {
      this.selectedFile = file;
    }
  },
  created() {
    this.closeModal();
    this.fetchDocumentTypeReferences();
  }
};
</script>
